import { render, staticRenderFns } from "./OsAntesDiscEditor.vue?vue&type=template&id=17767deb&scoped=true"
import script from "./OsAntesDiscEditor.vue?vue&type=script&lang=ts"
export * from "./OsAntesDiscEditor.vue?vue&type=script&lang=ts"
import style0 from "./OsAntesDiscEditor.vue?vue&type=style&index=0&id=17767deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17767deb",
  null
  
)

export default component.exports